module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select-input', {
    attrs: {
      "label": _vm.label,
      "value-key": "value",
      "label-value": "label",
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "list": _vm.selectData,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5911d74a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectLandType.vue
// module id = 1507
// module chunks = 0